module.exports = __webpack_public_path__ + "img/home-banner3.520f5072.jpg";